"use strict";
function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/util/isObject.js
// module id = 119
// module chunks = 16